/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import BN from 'bignumber.js';
import cn from 'classnames';
import theme from '../../../../../theme';
// TODO: move to utils
// import { getDuration } from '../../../../../components/util';
// import { formatToken } from '../../../../../helpers/token-helper';
import { TOKEN_OPTIONS, KSM } from '../../../../../constants/blockchain-constants';
import s from '../item.module.scss';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import {
  ColumnTotalStakedAmountTitle,
  ColumnStatusTitle,
  ColumnEstimatedAprTitle,
  ColumnEstimatedDailyRewardsTitle,
  ColumnEarnedRewardsTitle,
} from '../../../../../components/Stake/column';
import cutWalletAddress from '../../../../../util/cutWalletAddress';

const KusamaItem = ({ isActive, onClick, kusamaData }) => {
  const colors = useGetTheme();

  const getWrapBgColor = () => ({ style: { backgroundColor: colors.listAssetBackground } });
  const getTitleColor = () => ({ style: { color: colors.text } });

  return (
    <div className={cn(s.wrap, { [s.active]: isActive })} {...getWrapBgColor()} onClick={onClick}>
      <ColumnTotalStakedAmountTitle isMobile />
      <div className={s.col}>
        <div className={s.logoContainer}>
          <img className={s.logo} src={TOKEN_OPTIONS[KSM].icon} alt='' />
        </div>
        <div className={s.stakeBalance}>
          <p className={s.topLine} {...getTitleColor()}>
            {TOKEN_OPTIONS[KSM].title}{' '}
          </p>
        </div>
        <div />
      </div>
      <ColumnStatusTitle isMobile />
      <div className={cn(s.col, s.colColumn)}>
        <span className={s.topLine} style={{ color: theme.palette.mantra.pink, fontSize: '18px' }}>
          {kusamaData.nominatingData.length > 0 ? 'Nominating' : '—'}
        </span>
      </div>
      <ColumnEstimatedAprTitle isMobile />
      <div className={s.col}>
        <span
          className={s.topLine}
          style={{ fontSize: '12px', color: theme.palette.mantra.pink, display: 'inline-block' }}
        >
          {
            // Show preview of users voted validator nodes.
            // Show 2 addresses then '...'
            // eslint-disable-next-line max-len
            kusamaData.nominatingData.length > 0
              ? kusamaData.nominatingData.slice(0, 1).map((node) => (
                  <div key={`${node.nodeAddress}-dot-node`}>
                    {`Node: ${cutWalletAddress(node.nodeAddress)}`}
                    <br />
                  </div>
                ))
              : '—'
          }
        </span>
      </div>
      <ColumnEstimatedDailyRewardsTitle isMobile />
      <div className={s.col}>
        <span
          className={s.topLine}
          style={{ fontSize: '12px', color: 'rgb(208,65, 115)', display: 'inline-block' }}
        >
          {kusamaData.info
            ? kusamaData.info.targetAddress
              ? `KSM: ${cutWalletAddress(kusamaData.info.targetAddress)}`
              : '--'
            : '--'}
        </span>
      </div>
      <ColumnEarnedRewardsTitle isMobile />
      <div className={s.col} style={{ flexWrap: 'nowrap' }}>
        <span
          className={s.topLine}
          style={{ fontSize: '12px', color: 'rgb(208,65, 115)', display: 'inline-block' }}
        >
          {kusamaData.info
            ? kusamaData.info.ethereumAddress
              ? `Linked: ${cutWalletAddress(kusamaData.info.ethereumAddress)}`
              : '--'
            : '--'}
        </span>
      </div>
    </div>
  );
};

KusamaItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  kusamaData: PropTypes.object.isRequired,
};

export default connect((state) => ({
  kusamaData: state.delegator.kusama,
}))(KusamaItem);
